import { Link } from "react-router-dom";

import { PageHeader } from "../components/layout/PageHeader";

/** A path this console has no screen for. */
export function NotFoundPage(): JSX.Element {
  return (
    <>
      <PageHeader eyebrow="Not here" title="There is no screen at this address" />
      <p className="state-block">
        Nothing is wrong and nothing is lost — this console simply has no page
        here. <Link to="/">Go back to the clients.</Link>
      </p>
    </>
  );
}
